/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type CohortFilterGranularity = (typeof CohortFilterGranularity)[keyof typeof CohortFilterGranularity];

export const CohortFilterGranularity = {
  day: 'day',
  week: 'week',
  month: 'month',
  conversation: 'conversation',
} as const;
